import styled from 'styled-components';
import Box from './Box';

const PreviewContainer = styled(Box)`
  margin-top: 40px;
  white-space: pre-line;
  overflow: auto;
  & img {
    max-width: 100%;
  }
  &.office-365 {
    word-break: break-word;
  }
  & a{
    display: inline-block;
  }
  & table{
    width: auto!important;
    max-width: 100%!important;
    & td {
      word-break: break-word;
    }
  }
  & pre{
    max-width: 100%!important;
    word-break: break-word;
  }
  &.jira{
    padding-left: 0;
  }
`

export default PreviewContainer;